exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-615b68b8]{width:50%;margin:auto;padding:30px 0}label[data-v-615b68b8]{margin-top:20px}h1[data-v-615b68b8]{letter-spacing:.7px;color:#45be45;margin:20px 0;text-align:center;text-transform:uppercase}.btn-primary[data-v-615b68b8]{transition:all .3s}@media screen and (max-width:768px){div[data-v-615b68b8]{width:95%}h1[data-v-615b68b8]{font-size:24px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-615b68b8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Signin.vue
// module id = 648
// module chunks = 0